import { deprecated } from "typesafe-actions";

import { CurrencySelectionActionTypes } from "./constants";

const { createStandardAction } = deprecated;

/** modal input values are initialized */
export const openCurrencySelectionModal = createStandardAction(CurrencySelectionActionTypes.OPEN_CURRENCY_SELECTION_ASSEMBLY_MODAL)();

export const setCurrencySelectionModalData = createStandardAction(CurrencySelectionActionTypes.SET_CURRENCY_SELECTION_MODAL_DATA).map(
  (payload: { currentCurrency: string; availableCurrencies: string[] }) => ({ payload })
);

/**  modal input values are dropped */
export const closeCurrencySelectionModal = createStandardAction(CurrencySelectionActionTypes.CLOSE_CURRENCY_SELECTION_MODAL)();

export const clearCurrencySelectionData = createStandardAction(CurrencySelectionActionTypes.CLEAR_CURRENCY_SELECTION_DATA)();

/** update the updateKey in order to trigger a rerender on the priceRequest page - due to using currency selection inside of a modal without route update after a pricerequest */
export const updateCurrencySelectionModal = createStandardAction(CurrencySelectionActionTypes.UPDATE_CURRENCY_SELECTION).map(
  (payload: { selectedCurrency: string }) => ({ payload })
);
